import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

// import tablas
import { table } from '../../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class LoadEmailService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  loadEmail(objUnidad) {
    let emails = [];

    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.user}","objc":${JSON.stringify(objUnidad)}}`)
      .pipe(map
        ((res: []) => {
          res.forEach(element => {
            emails.push(element['user'][0] + '@agenciaeducacion.cl');
          });
          return emails;
        }));
  }
}
